import { z } from 'zod';

import { SUBJECT_MAX_LENGTH } from './constants';

/**
 * Regras do formulário de feedback da 404.
 *
 * Mensagens em pt-BR e no imperativo do que fazer ("Informe...", "Digite..."),
 * não no que deu errado — é o que o usuário precisa para consertar o campo.
 *
 * `sourceUrl` é opcional de verdade: o campo nasce vazio e string vazia é um
 * valor válido. Só quando há algo digitado a URL é exigida.
 */
export const feedbackSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Informe seu nome (ao menos 2 caracteres).')
    .max(120, 'O nome pode ter no máximo 120 caracteres.'),
  email: z
    .string()
    .trim()
    .min(1, 'Informe seu e-mail para que possamos responder.')
    .email('Digite um e-mail válido (ex.: nome@dominio.com.br).'),
  subject: z
    .string()
    .trim()
    .min(5, 'Descreva em poucas palavras o que você procurava.')
    .max(SUBJECT_MAX_LENGTH, `Use no máximo ${SUBJECT_MAX_LENGTH} caracteres.`),
  sourceUrl: z
    .string()
    .trim()
    .refine(
      (value) => value === '' || /^https?:\/\/\S+\.\S+/.test(value),
      'Cole o endereço completo, começando com https://',
    ),
});

export type FeedbackFormValues = z.infer<typeof feedbackSchema>;

export const FEEDBACK_INITIAL_VALUES: FeedbackFormValues = {
  name: '',
  email: '',
  subject: '',
  sourceUrl: '',
};
